<template>
  <zm-drawer
    ref="drawer"
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="open(false)"
  >
    <div slot="drawerBody" class="edit-person">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <a-input
                placeholder="请输入姓名"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
              <a-select
                :allowClear="true"
                placeholder="请选择性别"
                v-decorator="['gender', { rules: [{ required: true, message: '请选择性别！' }] }]"
              >
                <a-select-option v-for="(option, index) in genderList" :key="index" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="员工编号">
              <a-input
                placeholder="请输入员工编号"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['userNumber', { rules: [{ required: true, message: '请输入员工编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门">
              <a-tree-select
                show-search
                :filterTreeNode="filterTreeNode"
                style="width: 100%"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择所属部门"
                allow-clear
                tree-default-expand-all
                :treeData="deptList"
                @change="changeDept"
                v-decorator="['deptId', { rules: [{ required: true, message: '请选择所属部门！' }] }]"
              ></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="职位">
              <a-select
                :allowClear="true"
                placeholder="请选择职位"
                v-decorator="['departmentJob', { rules: [{ required: true, message: '请选择职位！' }] }]"
              >
                <a-select-option v-for="(option, index) in jobList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门主管">
              <a-input
                disabled
                v-decorator="['deptHeader', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="人员角色">
              <a-select
                :allowClear="true"
                placeholder="请选择人员角色"
                mode="multiple"
                :maxTagCount="1"
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption"
                v-decorator="['roleIds', { rules: [{ required: false, message: '请选择人员角色!' }] }]"
              >
                <a-select-option v-for="(item, index) in roleList" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在岗类型">
              <a-select
                :allowClear="true"
                placeholder="请选择在岗类型"
                v-decorator="['jobStatus', { rules: [{ required: false, message: '请选择在岗类型！' }] }]"
              >
                <a-select-option v-for="(option, index) in jobStatusList" :key="index" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入职日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择入职日期"
                v-decorator="['entryDate', { rules: [{ required: false, message: '请选择入职日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转正日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择转正日期"
                v-decorator="['formallyDate', { rules: [{ required: false, message: '请选择转正日期！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="毕业院校">
              <a-input
                placeholder="请输入毕业院校"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['school', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最高学历">
              <a-select
                :allowClear="true"
                placeholder="请选择最高学历"
                v-decorator="['education', { rules: [{ required: false }] }]"
              >
                <a-select-option v-for="(option, index) in educationList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="身份证">
              <a-input
                placeholder="请输入身份证号码"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['identityNum', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="籍贯">
              <a-cascader
                :options="areaList"
                :showSearch="{ filter }"
                placeholder="请选择籍贯"
                changeOnSelect
                v-decorator="['birthPlace', { rules: [{ required: false, message: '请选择籍贯！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input
                placeholder="请输入手机号码"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['tel', { rules: [{ required: false, message: '请输入手机号码！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <a-input
                placeholder="请输入电子邮箱"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['email', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="婚姻状况">
              <a-select
                :allowClear="true"
                placeholder="请选择婚姻状况"
                showSearch
                optionFilterProp="children"
                v-decorator="['maritalStatus', { rules: [{ required: false, message: '请选择婚姻状况!' }] }]"
              >
                <a-select-option v-for="(item, index) in maritalStatusList" :key="index" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政治面貌">
              <a-select
                :allowClear="true"
                placeholder="请选择政治面貌"
                v-decorator="['politicalStatus', { rules: [{ required: false, message: '请选择政治面貌!' }] }]"
              >
                <a-select-option v-for="(item, index) in politicalList" :key="index" :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="现住址">
              <a-input
                placeholder="请输入现住址"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['address', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="简历附件">
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="初评附件">
              <zm-upload
                ref="uploadScore"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="scoreFileList"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleScoreUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="offer附件">
              <zm-upload
                ref="uploadOffer"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="offerFileList"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleOfferUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="备注">
              <a-textarea
                placeholder="请输入备注"
                :rows="3"
                v-decorator="['remarks', { rules: [{ required: false, message: '请填写备注！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { insertUserBaseInfo, updateUserBaseInfo, getUserBaseInfo, getAllRoleList, getAreaList, getDeptInfo } from '@/api/baseInfo'
import { deleteChildren } from '@/utils/util'
import { getDictInfoByCode } from '@/api/dict'
import moment from 'moment'

export default {
  name: 'BaseInfoModal',
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'baseInfo_form' })
  },
  computed: {
    ...mapGetters(['selectedDept', 'deptList', 'jobList']),
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    }
  },
  // watch: {
  //   selectedDept () {
  //     if (this.selectedDept.id) {
  //       this.deptId = this.selectedDept.id
  //     } else {
  //       this.deptId = null
  //     }
  //   }
  // },
  data () {
    return {
      title: null,
      width: 900,
      infoLoading: false, // 编辑窗口，获取详情loading
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 22 }
      },
      colSpan: 6,
      model: {},
      type: 'MODAL_ADD', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      genderList: [
        { value: 1, label: '男' },
        { value: 2, label: '女' }
      ],
      // deptList: [],
      internshipList: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      educationList: [],
      platformList: [],
      userList: [],
      jobStatusList: [
        { value: 1, label: '正式' },
        { value: 2, label: '试用' },
        { value: 3, label: '实习' }
      ],
      roleList: [],
      politicalList: [],
      areaList: [],
      maritalStatusList: [
        { value: 1, label: '已婚' },
        { value: 0, label: '未婚' }
      ],
      // jobList: [],

      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: [],
      scoreFileList: [],
      offerFileList: []
    }
  },
  methods: {
    initDictData () {
      // 获取学历
      getDictInfoByCode({ pCode: 'education' }).then(res => {
        if (res.status === 0) {
          this.educationList = res.data
        }
      })
      // 获取邀约平台
      getDictInfoByCode({ pCode: 'PLATFORM_APPLICATION' }).then(res => {
        if (res.status === 0) {
          this.platformList = res.data
        }
      })
      // 获取面试官
      getUserBaseInfo({ status: 1, paging: false }).then(res => {
        if (res.status === 0) {
          this.userList = res.data
        }
      })
      // 获取人员角色
      getAllRoleList().then(res => {
        if (res.status === 0) {
          this.roleList = res.data
        }
      })
      // 获取政治面貌
      getDictInfoByCode({ pCode: 'POLITICAL' }).then(res => {
        if (res.status === 0) {
          this.politicalList = res.data
        }
      })
      // 获取地区数据
      getAreaList().then(res => {
        const data = deleteChildren(res.data)
        this.areaList = data
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      console.log('组织id', this.selectedDept)
      if (flag) {
        this.initDictData()
        if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
          this.getModelInfo()
        } else {
          // 
        }
      }
    },
    // 获取当前的model详情
    getModelInfo () {
      const birthPlace = []
      if (this.model.province) {
        birthPlace.push(this.model.province)
        if (this.model.city) {
          birthPlace.push(this.model.city)
          if (this.model.district) birthPlace.push(this.model.district)
        }
      }
      const data = {
        userName: this.model.userName,
        gender: this.model.gender,
        userNumber: this.model.userNumber,
        deptId: this.model.deptId.toString(),
        departmentJob: this.model.departmentJob,
        roleIds: this.model.roleIds.split(',').map(Number),
        jobStatus: this.model.jobStatus,
        entryDate: this.model.entryDate ? moment(this.model.entryDate) : undefined,
        formallyDate: this.model.formallyDate ? moment(this.model.formallyDate) : undefined,
        school: this.model.school,
        education: this.model.education,
        identityNum: this.model.identityNum,
        birthPlace: birthPlace.length ? birthPlace : undefined,
        tel: this.model.tel,
        email: this.model.email,
        maritalStatus: this.model.maritalStatus,
        politicalStatus: this.model.politicalStatus,
        address: this.model.address,
        remarks: this.model.remarks
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(data)

        this.fileList = this.model.fileList.filter(file => file.fileType === 1)
        this.scoreFileList = this.model.fileList.filter(file => file.fileType === 2)
        this.offerFileList = this.model.fileList.filter(file => file.fileType === 3)

        this.changeDept(this.model.deptId)
      })
    },
    // 提交表单
    handleSubmit () {
      this.btnLoading = true
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }

          // params.projectIds = params.projectIds.join(',')
          params.roleIds = params.roleIds.join(',')
          // if (params.groupIds) {
          //   params.groupIds = params.groupIds.join(',')
          // }
          if (params.birthPlace) {
            params.province = params.birthPlace[0] || ''
            params.city = params.birthPlace[1] || ''
            params.district = params.birthPlace[2] || ''
          }
          if (params.entryDate) params.entryDate = moment(params.entryDate).format('YYYY-MM-DD')
          if (params.formallyDate) params.formallyDate = moment(params.formallyDate).format('YYYY-MM-DD')
          const fileList = this.fileList.map(item => { return { ...item, fileType: 1 } })
          const scoreFileList = this.scoreFileList.map(item => { return { ...item, fileType: 2 } })
          const offerFileList = this.offerFileList.map(item => { return { ...item, fileType: 3 } })
          params.fileList = [...fileList, ...scoreFileList, ...offerFileList]

          console.log('submit', params)
          this.$refs.drawer.handleOkLoading(true)

          if (this.type === this.$sysInfo.MODAL_ADD) {
            const res = await insertUserBaseInfo(params).catch(() => {
              this.$refs.drawer.handleOkLoading(false)
              this.$message.error('操作失败，请重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id

            const res = await updateUserBaseInfo(params).catch(() => {
              this.$refs.drawer.handleOkLoading(false)
              this.$message.error('操作失败，请重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          }
        }

        this.btnLoading = false
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
      this.fileList = []
      this.scoreFileList = []
      this.offerFileList = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    changeDept (val) {
      this.form.setFieldsValue({ deptHeader: undefined })
      if (val) {
        // 获取部门主管
        getDeptInfo(val).then(res => {
          if (res.status === 0) {
            const headerInfo = res.data.headList
            if (headerInfo && headerInfo.length) {
              const names = headerInfo.map(item => { return item.headName }).join(',')
              this.form.setFieldsValue({ deptHeader: names })
            }
          }
        })
      }
    },
    // 简历上传
    handleUpload (fileList) {
      this.fileList = fileList
    },
    // 初评表上传
    handleScoreUpload (fileList) {
      this.scoreFileList = fileList
    },
    // offer上传
    handleOfferUpload (fileList) {
      this.offerFileList = fileList
    },

    filter (inputValue, path) {
      return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue.toLowerCase()) > -1
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style scoped></style>
